import { useTestIds } from "@homebound/beam";
import { useRouteParams } from "src/hooks/useRouteParams";
import { PlanBasedBidLinesSection } from "src/routes/projects/commitments/components/PlanBasedBidLinesSection";
import { usePlanBasedLineItemsTabQuery } from "src/routes/projects/commitments/components/PlanBasedLineItemsTab.generated";
import { ScopeLinesSection } from "src/routes/projects/commitments/components/ScopeLinesSection";
import { IdOrAddParams } from "src/routes/routesDef";
import { queryResult } from "src/utils";
import { PaymentScheduleSection } from "./PaymentScheduleSection";

export function PlanBasedLineItemsTab() {
  const tid = useTestIds({});
  const { idOrAdd: commitmentId } = useRouteParams<IdOrAddParams>();
  const query = usePlanBasedLineItemsTabQuery({ variables: { commitmentId } });

  return queryResult(query, ({ commitment: c }) => (
    <div {...tid.planBasedLineItems}>
      <PaymentScheduleSection commitment={c} />
      <PlanBasedBidLinesSection lineItems={c.lineItems} />
      <ScopeLinesSection lineItems={c.lineItems} />
    </div>
  ));
}
